export default [
  {
    component: () => import("@/components/auth/ForgotPasswordEmailForm.vue"),
    meta: { requiresGuest: true },
    name: "esqueci-minha-senha",
    path: "/esqueci-minha-senha",
  },
  {
    component: () => import("@/components/auth/PasswordResetForm.vue"),
    meta: { requiresGuest: true },
    name: "redefinir-senha",
    path: "/redefinir-senha/:token",
  },
  {
    component: () => import("@/components/auth/LoginForm.vue"),
    meta: { requiresGuest: true },
    name: "login",
    path: "/",
  },
  {
    component: () => import("@/components/auth/RegistrationForm.vue"),
    meta: { requiresGuest: true },
    name: "registro",
    path: "/registro",
  },
  {
    component: () => import("@/components/auth/EmitenteSelection.vue"),
    meta: { requiresAuth: true },
    name: "emitentes",
    path: "/emitentes",
    label: "Seleção de Emitentes",
  },
  {
    component: () => import("@/components/auth/SystemBlocked.vue"),
    meta: { requiresAuth: true, skipPermissionCheck: true },
    name: "bloqueado",
    path: "/bloqueado",
  },
  {
    component: () => import("@/components/auth/NoAccess.vue"),
    meta: { requiresAuth: true, skipPermissionCheck: true },
    name: "sem-acesso",
    path: "/sem-acesso",
  },
];
